<script setup>
import { ref, nextTick, defineExpose } from 'vue'
import Popover from 'primevue/popover'

/* ---------- Local state ---------- */
const op = ref()
const selectedRow = ref()

/* ---------- Methods ---------- */
const displayPopover = (event, row) => {
  op.value.hide()
  selectedRow.value = row
  nextTick(() => {
    if (row) op.value.show(event)
  })
}

const hidePopover = () => {
  op.value.hide()
}

/* ---------- Expose methods to parent ---------- */
defineExpose({
  displayPopover,
  hidePopover,
})
</script>

<template>
  <Popover
      ref="op"
      class="!bg-slate-700 !text-white !text-xs !border-slate-600 before:!hidden after:!hidden !mt-0 custom-popover"
      content-class="!p-0"
  >
    <div v-if="selectedRow" class="rounded p-2 max-w-sm bg-slate-800">
      <p class="leading-[1.5]">{{ selectedRow}}</p>
    </div>
  </Popover>
</template>
